import React, {
  createContext,
  useMemo,
  type PropsWithChildren,
} from "react";
import { QueryClientProvider } from "@tanstack/react-query";

import { axiosInstance } from "../../../api/axiosInstance";
import { queryClient } from "../library/queryClient";
import type { ReactQueryWrappersContextValue } from "../models";

export const ReactQueryWrappersContext =
  createContext<ReactQueryWrappersContextValue | null>(null);

export const ReactQueryWrappersProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const value = useMemo<ReactQueryWrappersContextValue>(
    () => ({
      axios: axiosInstance,
      queryClient,
    }),
    [],
  );

  return (
    <ReactQueryWrappersContext.Provider value={value}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ReactQueryWrappersContext.Provider>
  );
};
